import React from 'react'
import { Select, Input, Form, Button, Divider, message, Tabs, Anchor, Spin, Pagination, Tooltip, DatePicker, Steps } from 'antd'
import FormItem from 'antd/lib/form/FormItem'
import { ajaxApi, fileDownloadApiNew, getMethod } from '@/server/index'
import {getParmUrl} from '@/public/utils'
import moment from 'moment'
import 'moment/locale/zh-cn'
import lodash from 'lodash'
import common from '@/public/common'
import styles from './medical-equipmentn-onhaitao.module.less'
import DateChoose from '@/compenents/dateChoose'
import BasicInformation from './basic-information'
import RegistrationCertificateInformation from './registration-certificate-information'
import CooperationPolicy from './cooperation-policy'
const Option = Select.Option
const TabPane = Tabs.TabPane
const { RangePicker } = DatePicker
const { Step } = Steps
class MedicalEquipmentnOnhaitao extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      current: 0,
      postData: {
        item_id: ''
      }
    }
  }

  componentDidMount () {
    let {postData} = this.state
    if (getParmUrl('id')) {
      postData.item_id = getParmUrl('id')
      this.setState({
        postData
      }, () => {
        this.getBasicDetails()
      })
    }
  }

  // 获取详情
  getBasicDetails = async () => {
    let {postData, detailsData} = this.state
    try {
      let res = await ajaxApi({
        url:common.scpUrl + 'item/query-detail',
        params: postData
      })
      if (res.status === 200 && res.data) {
        sessionStorage.setItem('medicalCareOnHtaoData', JSON.stringify(res.data))
        this.setState({
          detailsData: res.data,
          current: 0
        })
      }
    } catch (e) {
      console.log(e)
    }
  }

  // 获取步骤条的参数
  getCurrent =(value) => {
    this.setState({
      current: value
    })
  }

  render () {
    return (
      <div className="addGood">
        <div className="search">
          <div style={{width: '70%', margin: '0 auto'}}>
            <Steps current={this.state.current}>
              <Step title="步骤1" description="填写商品基本信息" />
              <Step title="步骤2" description="填写注册证信息" />
              <Step title="步骤3" description="填写合作政策" />
            </Steps>
          </div>

          <div style={{width: '100%', margin: '0 auto', marginTop: '24px'}}>
            {this.state.current === 0 ? <BasicInformation history={this.props.history} getCurrent ={this.getCurrent}/> : (this.state.current === 1 ? <RegistrationCertificateInformation history={this.props.history} getCurrent ={this.getCurrent}/> : <CooperationPolicy history={this.props.history} getCurrent ={this.getCurrent}/>)}
          </div>
        </div>
      </div>
    )
  }
}
export default MedicalEquipmentnOnhaitao



// WEBPACK FOOTER //
// ./src/pages/commoditymanagement/addcompleteinformation/medicalequipmentnonhaitao/medical-equipmentn-onhaitao.js